import React from "react";

const Lean = () => {
  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-3 justify-center gap-40">
        {/* Lean Six Sigma Black Belt */}
        <div>
          <h2 className="bg-black p-5 text-white text-center text-[20px]">
            Lean Six Sigma Black Belt
          </h2>
          <p className=" mt-7">
            Lean Six Sigma Black Belt certification equips professionals to lead
            high-impact process improvement initiatives and provide strategic
            guidance to Green Belts within the organization. This advanced
            certification expands on Green Belt expertise, emphasizing mastery
            of the DMAIC (Define, Measure, Analyze, Improve, Control)
            methodology, sophisticated statistical analysis, and organizational
            change management. Black Belts play a pivotal role in driving
            operational excellence, enhancing process efficiency, and delivering
            sustainable, measurable business outcomes.
          </p>
          <h3 className="font-bold mt-7">Course Content:</h3>
          <p className="mt-7">
            1. Organization-Wide Planning and Deployment: <br />
            <br />
            A. Organization-wide Considerations <br />
            1. Fundamentals of Six Sigma and lean methodologies <br />
            2. Six Sigma, lean, and continuous improvement methodologies
            <br /> 3. Relationships among business systems and processes <br />
            4. Strategic planning and deployment for initiatives <br />
            <br />
            B. Leadership <br /> 1. Roles and responsibilities <br />
            2. Organizational barriers <br /> 3. Change management <br /> <br />
            2. Organizational Process Management and Measures: <br /> A. Impact
            on Stakeholders <br /> B. Benchmarking <br /> C. Business Measures
            <br />
            1. Performance measures <br /> 2. Financial measures <br />
            <br /> 3. Team Management : <br /> A. Team Formation <br /> 1. Team
            types and constraints <br /> 2. Team roles and responsibilities{" "}
            <br />
            3. Team member selection criteria <br /> 4. Team success factors
            <br /> <br /> B. Team Facilitation <br /> 1. Motivational techniques{" "}
            <br /> 2. Team stages of development <br /> 3. Team communication{" "}
            <br /> 4. Team leadership models <br /> <br /> C. Team Dynamics{" "}
            <br />
            1. Group behaviors <br /> 2. Meeting management <br />
            3. Team decision-making methods <br />
            <br />
            D. Team Training <br /> 1. Needs assessment <br /> 2. Delivery
            <br /> 3. Evaluation <br /> 4. Define : <br /> <br />
            A. Voice of the Customer <br /> 1.Customer Identification <br />
            2.Customer data collection <br /> 3.Customer requirements <br />
            <br />
            B. Business Case and Project Charter <br /> 1. Business case <br />{" "}
            2. Problem statement <br /> 3. Project scope <br /> 4. Goals and
            objectives <br /> 5. Project performance measurements <br /> 6.
            Project charter review <br />
            <br />
            C. Project Management (PM) Tools <br />
            1. Gantt charts <br />
            2. Toll-gate reviews <br /> 3. Work breakdown structure (WBS)
            <br /> 4. RACI model (responsible, accountable, consulted, and
            informed)
            <br />
            <br /> D. Analytical Tools <br /> 1. Affinity diagrams <br /> 2.
            Tree diagrams <br /> 3. Matrix diagrams <br /> 4. Prioritization
            matrices <br /> 5. Activity network diagrams <br />
            6. Process decision program chart (PDPC)
            <br /> 7. Interrelationship digraph (ID) <br />
            <br /> 5. Measure : <br /> A. Process Characteristics <br />
            1.Process flow metrics <br /> 2.Process analysis tools <br />
            <br /> B. Data Collection <br /> 1. Types of data <br />
            2. Measurement scales <br /> 3.Sampling <br /> 4. Data collection
            plans and methods <br />
            <br /> C. Measurement Systems <br /> 1. Measurement system analysis
            (MSA)
            <br /> 2. Measurement systems across the organization <br /> 3.
            Metrology <br />
            <br /> D. Basic Statistics <br />
            1. Basic statistical terms <br /> 2. Central limit theorem <br /> 3.
            Descriptive statistics <br /> 4. Graphical methods <br /> 5. Valid
            statistical conclusions <br />
            <br /> E. Probability <br /> 1. Basic concepts <br /> 2. Common
            distributions <br /> 3. Additional distributions <br />
            <br /> F. Process Capability <br /> 1.Process capability indices{" "}
            <br />
            2.Process performance indices <br /> 3.General process capability
            studies <br /> 4.Process capability for attributes data <br />
            5.Process capability for non-normal dat
            <br /> 6.Short-term and long-term capability <br />
            <br /> 6. Analyze :<br /> A. Measuring and Modeling Relationships
            Between Variables <br /> 1.Correlation coefficient <br /> 2.Linear
            regression <br /> 3.Multivariate tools
            <br />
            <br /> B. Hypothesis Testing <br /> 1.Terminology <br />
            2.Statistical vs. practical significance <br />
            3.Sample size <br /> 4.Point and interval estimates <br /> 5.Tests
            for means, variances, and proportions <br />
            <br />
            6.Analysis of variance (ANOVA)
            <br /> 7.Goodness-of-fit (chi square) tests <br />
            <br />
            C. Risk Analysis and Management <br />
            1. Types of risk <br /> 2. Failure mode and effects analysis
            <br />
            <br /> D. Additional Analysis Methods
            <br /> 1. Gap analysis
            <br /> 2. Root cause analysis
            <br /> 3. Waste analysis <br />
            <br /> 7. Improve : <br />
            A. Design of Experiments (DOE)
            <br /> 1.Terminology <br />
            2.Design principles
            <br /> 3.Planning experiments <br />
            4.One-factor experiments <br />
            5.Two-level fractional factorial experiments
            <br /> 6.Full factorial experiments <br />
            <br />
            B. Lean Methods <br />
            1. Waste elimination <br />
            2. Cycle-time reduction <br />
            3. Kaizen <br />
            4. Other improvement tools and techniques <br />
            <br />
            C. Implementation <br />
            8. Control : <br />
            A. Statistical Process Control (SPC) <br />
            1.Objectives <br />
            2.Selection of variables <br />
            3.Rational subgrouping <br />
            4.Control chart selection <br />
            5.Control chart analysis <br />
            <br />
            B. Other Controls <br />
            1. Total productive maintenance (TPM) <br />
            2. Visual controls <br />
            <br />
            C. Maintain Controls <br />
            1. Measurement system reanalysis
            <br /> 2. Control plan <br />
            <br />
            D. Sustain Improvements <br />
            1. Lessons learned <br />
            2. Documentation <br />
            3. Training for process owners and staff <br />
            4. Ongoing evaluation <br />
            <br />
            9. Design for Six Sigma (DFSS) Framework and Methodologies :<br />{" "}
            A. Common DFSS Methodologies <br />
            B. Design for X (DFX) <br />
            <br />
            C. Robust Designs <br />
            <br />
            Course Duration: The Lean Six Sigma Black Belt program is an
            intensive 6–8 week course, combining instructor-led sessions,
            practical case studies, and hands-on project work. The curriculum is
            designed to ensure participants achieve mastery over advanced
            process improvement tools, statistical analysis, and strategic
            implementation techniques. Certification Requirements To earn the
            Black Belt certification, 1. candidates must: Successfully complete
            the full training program. 2. Demonstrate proficiency through a
            rigorous assessment/exam. 3. Lead a real-world improvement project,
            applying the DMAIC methodology to deliver measurable business
            results. 4. Possess prior Green Belt certification or equivalent
            experience in Six Sigma projects is highly recommended.
          </p>
          <h3 className="font-bold mt-7">Certification Requirements</h3>
          <p>
            To earn the Black Belt certification, <br />
            1. candidates must: Successfully complete the full training program.
            <br /> 2. Demonstrate proficiency through a rigorous
            assessment/exam.
            <br /> 3. Lead a real-world improvement project, applying the DMAIC
            methodology to deliver measurable business results.
            <br /> 4. Possess prior Green Belt certification or equivalent
            experience in Six Sigma projects is highly recommended
          </p>
          <h3 className="font-bold mt-7">Who Should Attend?</h3>
          <p>
            This program is ideal for:
            <br /> 1. Mid- to senior-level professionals responsible for process
            improvement and operational excellence.
            <br /> 2. Project leaders and managers overseeing cross-functional
            teams.
            <br /> 3. Change agents and quality professionals seeking to
            implement strategic, sustainable improvements.
            <br /> 4.Individuals aspiring to mentor Green Belts and influence
            organizational performance at a strategic level.
          </p>
          <h3 className="font-bold mt-7">
            Benefits of Black Belt Certification
          </h3>
          <p>
            1. Gain advanced expertise in Lean Six Sigma methodologies and
            statistical tools. <br />
            2.Enhance leadership capabilities in driving complex process
            improvement initiatives. <br />
            3.Deliver measurable cost savings, efficiency gains, and quality
            enhancements.
            <br /> 4. Position yourself as a key driver of strategic operational
            excellence within your organization.
            <br /> 5. Expand career opportunities in management, operations, and
            quality leadership roles.
          </p>
          <h3 className="font-bold mt-7">
            Why Choose Mind Works for Black Belt?
          </h3>
          <p>
            Proven Expertise: Learn from certified Lean Six Sigma Black Belts
            with extensive industry experience. Practical Learning: Engage in
            real-world case studies and hands-on projects to ensure immediate
            applicability. Comprehensive Support: Receive mentorship throughout
            your project execution and exam preparation. Global Standards: Our
            program aligns with ASQ and international Lean Six Sigma standards,
            ensuring globally recognized certification. Career Advancement:
            Equip yourself with skills and credentials that accelerate
            professional growth and leadership opportunities.
          </p>
          <h3 className="font-bold mt-7">
            Who Should Get Six Sigma Black Belt Certified?
          </h3>
          <p>
            The Six Sigma Black Belt Certification is designed for professionals
            aiming to lead quality improvement initiatives and drive
            organizational excellence. As a Black Belt, you'll master Six Sigma
            philosophies and principles, including the DMAIC model, and develop
            team leadership skills to effectively manage projects.
          </p>
          <h3 className="font-bold mt-7">Why Get Certified?</h3>
          <p>
            - Gain industry recognition and enhance your career prospects.{" "}
            <br /> - Develop key problem-solving skills and lead quality
            improvement projects.
            <br /> - Stand out in competitive job markets with a respected
            credential.
            <br /> - Gain credibility with peers as a Six Sigma expert.
            <br /> - Increase your earning potential.
          </p>
        </div>
        <div>
          {" "}
          {/* Lean Six Sigma Green Belt */}
          <div>
            <h2 className="bg-green-600 p-5 text-white text-center text-[20px]">
              Lean Six Sigma Black Belt
            </h2>
            <p className=" mt-7">
              Lean Six Sigma Green Belt is a professional certification that
              focuses on process improvement and problem-solving by combining
              Lean (waste reduction) and Six Sigma (defect reduction)
              methodologies. Green Belts typically lead small to medium-sized
              projects and support Black Belts in larger initiatives. They apply
              tools such as DMAIC, root cause analysis, and data analysis to
              improve efficiency, reduce costs, save time, and enhance overall
              quality. This certification is highly valuable for professionals
              in manufacturing, operations, quality, and service industries who
              aim to drive continuous improvement within their organizations.
            </p>
            <h3 className="font-bold mt-7">Course Content:</h3>
            <p className="mt-7">
              1. Overview: Six Sigma and the Organization: <br /> A. Six Sigma
              and Organizational Goals <br />
              1. Value of Six Sigma <br />
              2. History of Lean Six sigma <br />
              3. Application of Lean Six Sigma
              <br /> 4. Organizational goals and Six Sigma projects
              <br /> 5. Organizational drivers and metrics
              <br />
              <br />
              B. Lean Principles in the Organization
              <br /> 1. Lean concepts <br /> 2. Value stream mapping
              <br />
              <br />
              C. Design for Six Sigma (DfSS) Methodologies
              <br /> 1. Road maps for DfSS <br /> 2. Basic failure mode and
              effects analysis (FMEA)
              <br /> 3. Design FMEA and process FMEA <br />
              <br />
              D. Understanding of basic statistics <br />
              <br />
              2. Define Phase: <br />
              A. Project Identification <br /> 1. Project selection <br /> 2.
              Process elements <br /> 3. Benchmarking <br /> 4. Process input
              and outputs <br /> 5. Owners and stakeholders B. Voice of the
              Customer (VoC) <br />
              1. Customer identification <br />
              2. Customer data
              <br /> 3. Customer requirements <br />
              <br />
              C. Project Management Basics <br />
              1. Project methodology <br />
              2. Project charter
              <br /> 3. Project scope <br />
              4. Project metrics <br />
              5. Project planning tools
              <br /> 6. Project documentation <br />
              7. Project risk analysis and management
              <br /> 8. Project closure <br />
              <br />
              D. Management and Planning Tools <br /> 1. Change management
              Concept <br />
              <br />
              E. Business Results for Projects <br /> 1. Process performance{" "}
              <br />
              2. Communication <br />
              <br />
              F. Team Dynamics and Performance <br />
              1. Process performance <br />
              2. Communication <br />
              <br />
              3. Measure Phase:
              <br /> A. Process Analysis and Documentation
              <br />
              <br /> B. Probability and Statistics <br /> 1. Basic probability
              concepts <br />
              2. Central limit theorem
              <br /> <br /> C. Statistical Distributions
              <br />
              <br /> D. Collecting and Summarizing Data <br />
              1. Types of data and measurement scales
              <br /> 2. Sampling and data collection plans and methods
              <br /> 3. Descriptive statistics <br />
              4. Graphical methods
              <br />
              <br />
              E. Measurement System Analysis (MSA) <br />
              <br /> F. Process and Performance Capability <br /> 1. Process
              performance vs. process specifications
              <br /> 2. Process capability studies <br /> 3. Process capability
              (Cp, Cpk) and process performance (Pp, Ppk) indices <br /> 4.
              Graphical methods <br /> <br />
              4. Analyze Phase: <br /> A. Exploratory Data Analysis
              <br />
              1.Multi-vari studies <br /> 2.Correlation and linear regression
              <br />
              <br /> B. Hypothesis Testing <br />
              1. Basics
              <br /> 2. Tests for means, variances, and proportions
              <br />
              <br /> C. Additional Analysis Methods <br />
              1. Gap analysis <br />
              2. Root cause analysis <br />
              <br />
              D. Collecting and Summarizing Data <br />
              1. Types of data and measurement scales <br />
              2. Sampling and data collection plans and methods <br />
              3. Descriptive statistics <br />
              4. Graphical methods <br />
              <br />
              E. Measurement System Analysis (MSA)
              <br />
              <br /> F. Process and Performance Capability <br />
              1. Process performance vs. process specifications
              <br /> 2. Process capability studies <br />
              3. Process capability (Cp, Cpk) and process performance (Pp, Ppk)
              indices <br />
              4. Graphical methods
              <br />
              <br /> 5. Improve Phase : <br />
              A. Design of Experiments (DoE) <br />
              1.Basic terms
              <br /> 2.DoE graphs and plots <br />
              <br />
              B. Implementation Planning <br />
              <br />
              C. Lean Tools <br />
              1. Waste elimination <br />
              2. Cycle-time reduction <br />
              3. Kaizen and kaizen blitz <br />
              <br />
              D. Collecting and Summarizing Data <br />
              1. Types of data and measurement scales <br />
              2. Sampling and data collection plans and methods
              <br /> 3. Descriptive statistics <br />
              4. Graphical methods <br />
              <br />
              E. Measurement System Analysis (MSA) <br />
              <br />
              F. Process and Performance Capability <br />
              1. Process performance vs. process specifications <br />
              2. Process capability studies
              <br /> 3. Process capability (Cp, Cpk) and process performance
              (Pp, Ppk) indices <br />
              4. Graphical methods
              <br />
              <br /> 6. Control Phase : <br />
              A. Statistical Process Control (SPC)
              <br /> 1.SPC Basics
              <br /> 2.Rational sub-grouping
              <br /> 3.Control charts <br />
              <br />
              B. Sustain Improvements <br />
              1.Control plan <br />
              2.Document control <br />
              3.Training plans <br />
              4.Audits <br />
              5.Plan-do-check-act (PDCA) <br />
              <br />
              C. Lean Tools for Process Control <br />
              1. Total productive maintenance (TPM) <br />
              2. Visual factory <br />
              <br /> Course Duration:
              <br /> The Green Belt program spans 40 hours, usually completed
              over 5 days, and is available in multiple formats including
              face-to-face training, virtual classes, or a mix of both.
            </p>
            <h3 className="font-bold mt-7">Certification Requirements</h3>
            <p>
              To obtain the Lean Six Sigma Green Belt certification,
              participants must successfully complete the required training
              program and pass a certification exam, which typically consists of
              around 100 multiple-choice questions. In addition, many
              certification bodies require candidates to demonstrate practical
              application by completing at least one Six Sigma project, although
              this requirement may vary depending on the organization. Earning
              the credential not only validates knowledge of Lean Six Sigma
              tools and methodologies but also showcases the ability to apply
              them effectively in real-world process improvement initiatives.
            </p>
            <h3 className="font-bold mt-7">Who Should Attend?</h3>
            <p>
              <br />
              1.Professionals aiming to grow their careers in quality management
              and process improvement <br /> 2. Supervisors, team leaders, and
              managers focused on enhancing operational performance <br /> 3.
              Engineers, business analysts, and consultants engaged in process
              optimization initiatives <br />
              4. Individuals intending to progress toward advanced Six Sigma
              certifications such as Black Belt initiatives.
            </p>
            <h3 className="font-bold mt-7">
              Benefits of Black Belt Certification
            </h3>
            <p>
              1. Expands career prospects and enhances professional growth
              opportunities <br /> 2. Develops strong analytical and
              problem-solving capabilities <br /> 3. Supports organizations in
              minimizing costs while boosting customer satisfaction <br /> 4.
              Prepares individuals to effectively lead and contribute to Six
              Sigma initiatives
            </p>
            <h3 className="font-bold mt-7">
              Why Choose Mind Works for Green Belt?
            </h3>
            <p>
              Practical Training: Hands-on exercises and real-life case studies
              for immediate workplace application. Expert Guidance:
              Industry-certified trainers provide Lean implementation and
              problem-solving skills. Credible Certification: Recognized
              certificate with mentorship support for career growth and project
              success.
            </p>
            <h3 className="font-bold mt-7">
              Who Should Get Six Sigma Green Belt Certified?
            </h3>
            <p>
              A Six Sigma Green Belt plays a critical role in quality
              improvement projects, working alongside or under the guidance of a
              Six Sigma Black Belt. This certification is ideal for
              professionals with at least three years of work experience who
              want to showcase their expertise in Six Sigma tools, data-driven
              problem-solving, and process optimization.
            </p>
            <h3 className="font-bold mt-7">Why Get Certified?</h3>
            <p>
              - Gain industry recognition and enhance your career prospects.
              <br />
              -Develop key problem-solving skills and lead quality improvement
              projects.
              <br /> -Stand out in competitive job markets with a respected
              credential.
              <br /> - Increase your earning potential.
            </p>
          </div>
        </div>
        <div>
          {" "}
          {/* Lean Six Sigma Yellow Belt */}
          <div>
            <h2 className="bg-yellow-600 p-5 text-black text-center text-[20px]">
              Lean Six Sigma Yellow Belt
            </h2>
            <p className=" mt-7">
              The Lean Six Sigma Yellow Belt certification is an entry-level
              program that introduces professionals to the fundamental
              principles of Lean and Six Sigma. Yellow Belts gain practical
              knowledge of process improvement concepts, including waste
              reduction, defect minimization, and problem-solving techniques.
              While they do not typically lead projects, Yellow Belts play a
              vital role in supporting Green Belt and Black Belt initiatives by
              contributing to data collection, process mapping, and team-based
              improvement activities. This certification provides participants
              with the skills to identify inefficiencies, assist in driving
              improvement initiatives, and support organizational quality
              objectives across industries.
            </p>
            <h3 className="font-bold mt-7">Course Content:</h3>
            <p className="mt-7">
              1. Six Sigma Fundamentals:
              <br /> A. Six Sigma Foundation and Principles <br /> B. Lean
              Foundation and Principles <br />
              C. Six Sigma Roles and Responsibilities <br />
              D. Team Basics <br /> 1. Types of teams <br />
              2. Stages of development <br />
              3. Decision-making tools <br />
              4. Communication methods
              <br />
              <br />
              2. Define Phase: <br /> A. Project Identification
              <br /> 1. Voice of the customer <br />
              2. Project selection <br />
              3. Stakeholder analysis <br />
              4. Process inputs and outputs
              <br />
              <br /> B. Project Management (PM) Basics <br />
              1. Project charter <br />
              2. Communication plan <br />
              3. Project planning <br />
              4. Project management tools <br />
              5. Phase reviews <br />
              <br />
              3. Measure Phase :<br /> A. Basic Statistics
              <br />
              <br /> B.Data Collection <br />
              1. Data collection plans <br />
              2. Qualitative and quantitative data <br />
              3. Data collection techniques
              <br />
              <br /> C. Measurement System Analysis (MSA) <br />
              1. MSA terms <br />
              2. Gauge repeatability and reproducibility (GR & R) <br /> <br />
              4. Analyze Phase :<br /> A. Process Analysis Tools <br /> 1.Lean
              tools <br />
              2.Failure mode and effects analysis (FMEA) <br /> <br />
              B. Root Cause Analysis <br />
              C. Corrective action
              <br /> D. Preventive action <br />
              E. Data analysis <br />
              1. Basic distribution types
              <br /> 2. Common and special cause variation
              <br /> F. Correlation and regression <br />
              1. Correlation 2. Regression <br />
              G. Hypothesis testing
              <br />
              <br />
              5. Improve and Control Phases : <br />
              A. Improvement techniques <br />
              1.Kaizen and kaizen blitz <br />
              2.Plan-do-check-act (PDCA) cycle <br />
              3.Cost-benefit analysis <br />
              <br />
              B. Control Tools and Documentation <br />
              1. Control plan <br /> 2. Control chart <br /> 3. Document control
              4. Work instructions and standard operating procedures (SOPs){" "}
              <br />
              <br />
              Course Duration:
              <br /> The Yellow Belt program spans 24 hours, usually completed
              over 3 days, and is available in multiple formats including
              face-to-face training, virtual classes, or a mix of both.
            </p>
            <h3 className="font-bold mt-7">Certification Requirements</h3>
            <p>
              To obtain the Lean Six Sigma Yellow Belt certification,
              participants must successfully complete the required training
              program and pass a certification exam, which generally consists of
              multiple-choice questions focused on Lean Six Sigma fundamentals.
              Unlike Green or Black Belts, Yellow Belts are not typically
              required to complete independent projects. Instead, they are
              assessed on their ability to understand core concepts, support
              project teams, and apply basic Lean Six Sigma tools in real-world
              scenarios. Earning this credential validates a professional’s
              foundational knowledge of Lean Six Sigma methodologies and
              demonstrates their readiness to contribute to process improvement
              initiatives within their organization.
            </p>
            <h3 className="font-bold mt-7">Who Should Attend?</h3>
            <p>
              <br />
              1. Professionals seeking an introduction to Lean Six Sigma
              principles.
              <br /> 2. Team members who support improvement projects led by
              Green Belts or Black Belts.
              <br /> 3. Employees aiming to strengthen problem-solving and
              process awareness skills. <br /> 4.Individuals preparing to
              progress toward advanced certifications such as Green Belt or
              Black Belt.
            </p>
            <h3 className="font-bold mt-7">
              Benefits of Yellow Belt Certification
            </h3>
            <p>
              1. Builds a strong foundation in Lean Six Sigma tools and
              concepts.
              <br /> 2.Equips professionals to actively support improvement
              projects as effective team members.
              <br /> 3.Enhances problem-solving, process analysis, and waste
              reduction skills.
              <br /> 4. Provides a recognized credential that strengthens career
              prospects and serves as a pathway to higher-level certifications.
            </p>
            <h3 className="font-bold mt-7">
              Why Choose Mind Works for Yellow Belt?
            </h3>
            <p>
              Practical Training: Hands-on exercises and real-life case studies
              for immediate workplace application. Expert Guidance:
              Industry-certified trainers provide Lean implementation and
              problem-solving skills. Credible Certification: Recognized
              certificate with mentorship support for career growth and project
              success.
            </p>
            <h3 className="font-bold mt-7">
              Who Should Get Six Sigma Yellow Belt Certified?
            </h3>
            <p>
              A Six Sigma Yellow Belt provides essential support in quality
              improvement projects, working as a team member under the guidance
              of Green Belts or Black Belts. This certification is ideal for
              professionals who want to gain a foundational understanding of
              Lean Six Sigma principles, develop basic problem-solving skills,
              and actively contribute to process improvement initiatives within
              their organization.
            </p>
            <h3 className="font-bold mt-7">Why Get Certified?</h3>
            <p>
              - Gain recognition by building a strong foundation in Lean Six
              Sigma. <br /> - Develop essential problem-solving and process
              improvement skills. <br />- Contribute effectively as a team
              member in quality improvement projects.
              <br /> - Strengthen your career profile with a globally respected
              credential.
              <br /> - Establish a pathway toward advanced certifications such
              as Green Belt and Black Belt. .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lean;
